/* eslint-disable @typescript-eslint/no-explicit-any */
import { Listbox } from '@headlessui/react'
import clsx from 'clsx'
import { type ReactNode } from 'react'

interface FormSelectProps {
  children: ReactNode
  isError?: boolean | string
  disabled?: boolean
  value: any
  onClick?: ((value: string) => void) | null
  className?: string
}

export function FormSelectItem({
  children,
  isError,
  className = '',
  disabled = false,
  value,
  onClick = null,
}: FormSelectProps) {
  return (
    <Listbox.Option
      {...(onClick !== null
        ? {
            onClick: () => {
              onClick(value)
            },
          }
        : {})}
      className={({ selected }) =>
        clsx(
          selected ? 'bg-gray-300' : '',
          className && className,
          isError ? '!border-states-error' : 'border-primary',
          'p-4 hover:bg-gray-300'
        )
      }

      value={value}
      disabled={disabled}
    >
      {children}
    </Listbox.Option>
  )
}

export default FormSelectItem
